import assetPath from '/app/packages/entity-pages/entity-pages-jobs/src/assets/bookmark-fill.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')